(() => {
  "use strict";

  // Hard-coded homepage: test 124's layout with the Omniconvert code removed.
  // Hides #PageContainer and builds the new page into #hpo-root after it.
  //
  // Install: upload as assets/homepage-override.js and load it from <head> in
  // layout/theme.liquid, homepage only. NO defer/async - the hide rule has to
  // land before first paint, or the old homepage flashes first.
  const ROOT_ID = "hpo-root";

  // #abNNN-root: the Omniconvert homepage tests' pages. Safety net in case one
  // of those experiments is still running - stop them in Omniconvert too.
  const HIDDEN_SECTIONS = [
    "#PageContainer",
    "#backtotop",
    "#ab121-root",
    "#ab122-root",
    "#ab124-root",
  ];

  const ANCHOR = "#PageContainer";

  const ICON_FACEBOOK = `<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M9.101 23.691v-7.98H6.627v-3.667h2.474v-1.58c0-4.085 1.848-5.978 5.858-5.978.401 0 .955.042 1.468.103a8.68 8.68 0 0 1 1.141.195v3.325a8.623 8.623 0 0 0-.653-.036 26.805 26.805 0 0 0-.733-.009c-.707 0-1.259.096-1.675.309a1.686 1.686 0 0 0-.679.622c-.258.42-.374.995-.374 1.752v1.297h3.919l-.386 2.103-.287 1.564h-3.246v8.245C19.396 23.238 24 18.179 24 12.044c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.628 3.874 10.35 9.101 11.647Z"/></svg>`;
  const ICON_INSTAGRAM = `<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M7.0301.084c-1.2768.0602-2.1487.264-2.911.5634-.7888.3075-1.4575.72-2.1228 1.3877-.6652.6677-1.075 1.3368-1.3802 2.127-.2954.7638-.4956 1.6365-.552 2.914-.0564 1.2775-.0689 1.6882-.0626 4.947.0062 3.2586.0206 3.6671.0825 4.9473.061 1.2765.264 2.1482.5635 2.9107.308.7889.72 1.4573 1.388 2.1228.6679.6655 1.3365 1.0743 2.1285 1.38.7632.295 1.6361.4961 2.9134.552 1.2773.056 1.6884.069 4.9462.0627 3.2578-.0062 3.668-.0207 4.9478-.0814 1.28-.0607 2.147-.2652 2.9098-.5633.7889-.3086 1.4578-.72 2.1228-1.3881.665-.6682 1.0745-1.3378 1.3795-2.1284.2957-.7632.4966-1.636.552-2.9124.056-1.2809.0692-1.6898.063-4.948-.0063-3.2583-.021-3.6668-.0817-4.9465-.0607-1.2797-.264-2.1487-.5633-2.9117-.3084-.7889-.72-1.4568-1.3876-2.1228C21.2982 1.33 20.628.9208 19.8378.6165 19.074.321 18.2017.1197 16.9244.0645 15.6471.0093 15.236-.005 11.977.0014 8.718.0076 8.31.0215 7.0301.0839m.1402 21.6932c-1.17-.0509-1.8053-.2453-2.2287-.408-.5606-.216-.96-.4771-1.3819-.895-.422-.4178-.6811-.8186-.9-1.378-.1644-.4234-.3624-1.058-.4171-2.228-.0595-1.2645-.072-1.6442-.079-4.848-.007-3.2037.0053-3.583.0607-4.848.05-1.169.2456-1.805.408-2.2282.216-.5613.4762-.96.895-1.3816.4188-.4217.8184-.6814 1.3783-.9003.423-.1651 1.0575-.3614 2.227-.4171 1.2655-.06 1.6447-.072 4.848-.079 3.2033-.007 3.5835.005 4.8495.0608 1.169.0508 1.8053.2445 2.228.408.5608.216.96.4754 1.3816.895.4217.4194.6816.8176.9005 1.3787.1653.4217.3617 1.056.4169 2.2263.0602 1.2655.0739 1.645.0796 4.848.0058 3.203-.0055 3.5834-.061 4.848-.051 1.17-.245 1.8055-.408 2.2294-.216.5604-.4763.96-.8954 1.3814-.419.4215-.8181.6811-1.3783.9-.4224.1649-1.0577.3617-2.2262.4174-1.2656.0595-1.6448.072-4.8493.079-3.2045.007-3.5825-.006-4.848-.0608M16.953 5.5864A1.44 1.44 0 1 0 18.39 4.144a1.44 1.44 0 0 0-1.437 1.4424M5.8385 12.012c.0067 3.4032 2.7706 6.1557 6.173 6.1493 3.4026-.0065 6.157-2.7701 6.1506-6.1733-.0065-3.4032-2.771-6.1565-6.174-6.1498-3.403.0067-6.156 2.771-6.1496 6.1738M8 12.0077a4 4 0 1 1 4.008 3.9921A3.9996 3.9996 0 0 1 8 12.0077"/></svg>`;
  const ICON_YOUTUBE = `<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>`;
  const ICON_TIKTOK = `<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/></svg>`;

  const SOCIAL_LINKS = [
    {
      label: "Facebook",
      href: "https://www.facebook.com/prismplus/",
      icon: ICON_FACEBOOK,
    },
    {
      label: "Instagram",
      href: "https://www.instagram.com/prismplus/",
      icon: ICON_INSTAGRAM,
    },
    {
      label: "YouTube",
      href: "https://youtube.com/@prismplussg?si=_gGNKSSNy_8aFE3c",
      icon: ICON_YOUTUBE,
    },
    {
      label: "TikTok",
      href: "https://www.tiktok.com/@prismplus?lang=en",
      icon: ICON_TIKTOK,
    },
  ];

  const APP_LINKS = [
    {
      label: "Download on the App Store",
      href: "https://apps.apple.com/sg/app/prism-connect-smart-home/id6443871305",
      image:
        "https://cdn.shopify.com/s/files/1/1595/6213/files/iOS.png?v=1675238232",
    },
    {
      label: "Get it on Google Play",
      href: "https://play.google.com/store/apps/details?id=com.prism.oasis&hl=en_SG&pli=1",
      image:
        "https://cdn.shopify.com/s/files/1/1595/6213/files/Android.png?v=1675238232",
    },
  ];

  const BUNDLE_BAR = {
    text: "Bundle our products for an extra up to 10% off and priority delivery with MyHome Bundle.",
    textMobile: "Unlock extra savings with MyHome Bundle.",
    link: { label: "Find out more", href: "/pages/myhomebundle" },
  };

  const FONT_URL =
    "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap";

  const HERO_IMAGE =
    "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/MastheadPayDay_Desktop.jpg?v=1790159899";

  const HERO_IMAGE_MOBILE =
    "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/MastheadPayDay_Mobile.jpg?v=1790159890";

  const HERO_LOGO = "";

  // Drives the promo countdown and the hero eyebrow; both hide once it passes.
  // Keep the +08:00 - a bare date string parses as UTC and ends 8 hours early.
  const SALE_END = new Date("2026-10-13T10:00:00+08:00");

  // `eyebrow` is the prefix only - the SALE_END date is appended to it.
  const HERO = {
    eyebrow: "10.10 SALE: Ends 12 October",
    title: "The Fast Lane to Bigger Savings",
    subtitle: "",
    primary: null,
  };

  const ICON_CHEVRON_LEFT = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15.75 19.5 8.25 12l7.5-7.5"/></svg>`;
  const ICON_CHEVRON_RIGHT = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m8.25 4.5 7.5 7.5-7.5 7.5"/></svg>`;

  // Keep the &width=160: the source PNGs are up to 5.4MB each and render at 56px.
  const CATEGORY_SHORTCUTS = [
    { label: "Google TV", href: "/collections/tvs", image: "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/5c1207799b4ded64e72753028f6449ee9b16252a.png?v=1789614998&width=160" },
    { label: "Aircon", href: "/products/prism-neo", image: "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/a28a35c9907e804a557cdc5cacaecb3362c9b1ea.png?v=1789621196&width=160" },
    { label: "Fridge", href: "/collections/refrigerators", image: "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/0204e18d4418525fb428182f8b8fae849f83f648.png?v=1789614999&width=160" },
    { label: "Laundry", href: "/collections/laundry-appliances", image: "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/46d78080caaeba4b5cef3a65d1b6f701a66fbb15.png?v=1789614994&width=160" },
    { label: "Smart Lock", href: "/collections/locks", image: "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/d7692e90676dc204a7b736e1744a9d8229f27f3f.png?v=1789614996&width=160" },
    { label: "Fan", href: "/collections/smart-ceiling-fans", image: "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/aaebbdf0dfcf9d04465bcf3729c0d117b6ea411a.png?v=1789621172&width=160" },
    { label: "Monitor", href: "/collections/gaming-monitors", image: "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/ff0b577812f991cbaa818a5140b7b632696adf16.png?v=1789614985&width=160" },
    { label: "Air Purifier", href: "/collections/smart-air-purifiers", image: "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/b4ad8af2a58a045fe8f5e9f2768713fcf3da512e.png?v=1789621141&width=160" },
    { label: "Vacuum", href: "/collections/vacuum", image: "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/c3f0caa43fc73ee033600273e2b9b24f9aa12530.png?v=1789614999&width=160" },
  ];

  // ── promo section ───────────────────────────────────────────────────────
  // Per campaign, swap PROMO_TITLE, PROMO_CARDS and SALE_END.
  const PROMO_TITLE = "10.10 Podium Deals";

  // <b> is the phrase the design bolds; <br> is where it breaks the line.
  // Card art is 760x780, exactly 2x the 380x390 card.
  const PROMO_CARDS = [
    {
      theme: "dark",
      eyebrow: "Further price drops",
      title: "TVs",
      body: "<b>Upsized Discounts on Soundbar Bundles</b><br>for all TVs",
      price: "From $319",
      cta: { label: "Shop TVs", href: "/collections/tvs" },
      image:
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/TVs_bc6952a5-f071-4639-93d0-ee6c863599ff.jpg?v=1788429451",
    },
    {
      theme: "dark",
      eyebrow: "Lowest prices ever",
      title: "Monitors",
      body: "Price drops on selected models",
      price: "From $359",
      cta: { label: "Shop Monitors", href: "/collections/gaming-monitors" },
      image: "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Monitors.jpg?v=1788429451",
    },
    {
      theme: "light",
      eyebrow: "Free upgrade",
      title: "Aircons",
      body: "<b>Free QLED TV or Fridge</b><br>with Every System 3+ Purchase",
      price: "From $3,449",
      cta: { label: "Shop Aircons", href: "/products/prism-neo" },
      image:
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/ACs_0353d6ac-fd79-49f6-abdb-079c31a4ceac.jpg?v=1788429450",
    },
    {
      theme: "light",
      eyebrow: "Further price drops",
      title: "Lifestyle Displays",
      body: "<b>Up to $400 off</b> on Roam display models",
      price: "From $949",
      cta: { label: "Shop TVs", href: "/collections/tvs" },
      image: "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Roam.jpg?v=1788429450",
    },
    {
      theme: "light",
      eyebrow: "Free gift",
      title: "Laundry",
      body: "<b>FREE EvoSonic Pro 2 Vacuum</b><br>on all Laundry Bundles.",
      price: "From $768",
      cta: { label: "Shop Laundry", href: "/collections/laundry-appliances" },
      image: "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/LaundryBundle.jpg?v=1788429451",
    },
    {
      theme: "light",
      eyebrow: "Free upgrade",
      title: "Ceiling Fans",
      body: "Warranty upgraded from<br><b>1 to 4 years, all parts + labour</b>",
      price: "From $174",
      cta: {
        label: "Shop Ceiling Fans",
        href: "/collections/smart-ceiling-fans",
      },
      image: "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/CFs.jpg?v=1788429450",
    },
    {
      theme: "light",
      eyebrow: "Free gift",
      title: "Handheld Vacuum",
      body: "<b>Free EvoHub Elite Vacuum Stand</b><br>with EvoSonic Dust Station Elite Set",
      price: "From $338.90",
      cta: { label: "Shop Vacuum", href: "/collections/vacuum" },
      image: "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/HHV_63adc226-e32e-492c-9e38-7f547552e466.jpg?v=1791446790",
    },
    {
      theme: "light",
      eyebrow: "Further price drops",
      title: "Robot Vacuums",
      body: "<b>Up to $270 off</b> on NanoBot Pro",
      price: "From $379",
      cta: { label: "Shop Vacuums", href: "/collections/vacuum" },
      image: "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/RobotVacuum.jpg?v=1788429451",
    },
    {
      theme: "light",
      eyebrow: "Free gift",
      title: "Fridges",
      body: "<b>FREE EvoSonic Pro 2 Vacuum</b><br>with selected Fridge models",
      price: "From $1,199",
      cta: { label: "Shop Fridges", href: "/collections/refrigerators" },
      image: "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Fridges.jpg?v=1788429450",
    },
    {
      theme: "light",
      eyebrow: "Lowest prices ever",
      title: "Air Purifiers",
      body: "<b>Price drops</b> on Vortex &amp; Vortex Pro Cannoli Cream",
      price: "From $179",
      cta: {
        label: "Shop Air Purifiers",
        href: "/collections/smart-air-purifiers",
      },
      image: "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/APs_Cannoli_Cream.jpg?v=1791446789",
    },
    {
      theme: "dark",
      eyebrow: "Further price drops",
      title: "Smart Locks",
      body: "<b>Up to $250 off</b> on Spectre Lock Bundles",
      price: "From $849",
      cta: { label: "Shop Smart Locks", href: "/collections/locks" },
      image: "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/SpectreBundle.jpg?v=1788429451",
    },
  ];

  const FEATURE_CARDS = [
    {
      theme: "dark",
      title: "Solaris Pro",
      subtitle: "Award-winning laundry rack design, built for local homes.",
      price: "From $699",
      was: "$899",
      primary: {
        label: "Shop now",
        href: "https://prismplus.sg/products/prism-solaris-pro",
      },
      video:
        "https://cdn.shopify.com/videos/c/o/v/a7752e58dd794171bbcba19ab96816f8.mp4",
      image: "",
    },
    {
      theme: "light",
      title: "EvoSonic Ultra 2 Dust Station",
      subtitle: "Now with EvoPod, the auto-empty charging dock.",
      price: "From $228",
      was: "$498",
      primary: {
        label: "Shop now",
        href: "https://prismplus.sg/products/evosonic-ultra-detect-2-evopod",
      },
      image:
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/EvoSonic_Dust_Station_27648223-1d88-42d4-a129-5adece78a36c.jpg?v=1791535501",
      // <=749px art: 900x1000, product in the bottom half. Blank = `image`.
      imageMobile: "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/EvoSonic_Dust_Station_Mobile.jpg?v=1791538235",
    },
  ];

  // "Compare models" opens the theme's own TV compare popup, fetched from the
  // TVs collection on demand. The section id below changes on every theme
  // publish; when stale, the loader falls back to the full collection page
  // (slower, still works). To get the fast path back, read the new id with:
  //   curl -s https://prismplus.sg/collections/tvs \
  //     | grep -o 'shopify-section-template--[0-9]*__product_compare_group_[A-Za-z0-9]*'
  const COMPARE_PAGE_URL = "/collections/tvs";
  const COMPARE_SECTION_URL = `${COMPARE_PAGE_URL}?section_id=template--23014840107235__product_compare_group_A6gQPQ`;
  const COMPARE_SCRIPT = "tv-compare.js";

  const SHOWCASE = {
    title: "Best-selling Google TVs",
    subtitle: "The models local homes buy most.",
    primary: {
      label: "Shop all TVs",
      href: "/collections/tvs",
    },
    secondary: {
      label: "Compare models",
      href: "",
    },
    background:
      "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/7e2198f42300fac33133542b1e3269d99d8613bf.png?v=1788854810",
    products: [
      {
        name: "Q55-QE 2026",
        spec: "Q-Series Quantum Edition<br>4K AI Google TV",
        price: "From $599",
        href: "/products/q55qe-2026",
        image:
          "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Q55QE_Product_Card.jpg?v=1788943941",
      },
      {
        name: "Q65 Ultra 2026",
        spec: "Q-Ultra Series QLED+ 120Hz<br>4K AI Google TV",
        price: "From $1,099",
        href: "/products/q65u-2026",
        image:
          "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Q65U_Product_Card.jpg?v=1788943942",
      },
      {
        name: "U55 2026",
        spec: "U-Series Quantum Dot Mini-LED<br>4K AI Google TV",
        price: "From $999",
        href: "/products/u55-2026",
        image:
          "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/U55_Product_Card.jpg?v=1788943941",
      },
      {
        name: "U65 Ultra",
        spec: "U-Ultra Series Quantum Dot<br>Mini-LED 144Hz 4K AI Google TV",
        price: "From $2,299",
        href: "/products/prism-u65-ultra-qd-mini-led-4k-ai-google-tv",
        image:
          "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/U65U_Product_Card.jpg?v=1788943941",
      },
    ],
  };

  const CATEGORIES_TITLE =
    "Across every category. Not just the ones you\u2019d expect.";

  const CATEGORY_CARDS = [
    {
      title: "TV",
      subtitle: "Our sharpest picture yet.",
      price: "From $319",
      href: "/collections/tvs",
      image:
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/TVs_b9c0ce2a-61e1-4d33-ba5e-99f980eae9f8.jpg?v=1788926711",
    },
    {
      title: "Soundbar",
      subtitle: "Room-filling sound, made to match.",
      price: "From $299",
      href: "/collections/soundbar",
      image:
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Soundbars.jpg?v=1788926710",
    },
    {
      title: "Monitor",
      subtitle: "Built for work and play.",
      price: "From $108",
      href: "/collections/gaming-monitors",
      image:
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Monitors_a8053312-f187-407e-9acb-5a25b1234cab.jpg?v=1788926710",
    },
    {
      title: "Aircon",
      subtitle: "Cool that's tuned for the tropics.",
      price: "From $1,039",
      href: "/products/prism-neo",
      image:
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/ACs_dae16527-1ee3-486a-a42b-ee5f512b7b5d.jpg?v=1788926710",
    },
    {
      title: "Fans",
      subtitle: "Quiet air, all day.",
      price: "From $199",
      href: "/collections/smart-ceiling-fans",
      image:
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/CFs_215af6cc-6e36-4d89-805e-e6a8db2735f1.jpg?v=1788926709",
    },
    {
      title: "Air Purifier",
      subtitle: "Cleaner air, every room.",
      price: "From $169",
      href: "/collections/smart-air-purifiers",
      image:
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/APs_e47799fa-a8f1-48df-ac6b-915cb46a32ee.jpg?v=1788926711",
    },
    {
      title: "Washers & Dryers",
      subtitle: "Laundry day, sorted.",
      price: "From $299",
      href: "/collections/laundry-appliances",
      image:
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Laundry_3701cf60-821f-488d-8abe-1710fe18c994.jpg?v=1788926710",
    },
    {
      title: "Laundry Racks",
      subtitle: "Award-winning, built for local homes.",
      price: "From $469",
      href: "/collections/laundry-appliances",
      image:
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/LaundryRacks.jpg?v=1788926710",
    },
    {
      title: "Fridges",
      subtitle: "Fresh, kept longer.",
      price: "From $185",
      href: "/collections/refrigerators",
      image:
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Fridges_e56c75c3-8a52-4332-88bd-3d468896b0a6.jpg?v=1788926710",
    },
    {
      title: "Handheld Vacuums",
      subtitle: "Wet and dry, in one hand.",
      price: "From $89",
      href: "/collections/vacuum",
      image:
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/CordlessVacuum.jpg?v=1788926710",
    },
    {
      title: "Robot Vacuums",
      subtitle: "It cleans. You don't.",
      price: "From $449",
      href: "/collections/vacuum",
      image:
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/RobotVacuum_5ad35c39-fac3-4999-9abb-34ecc0aca0a6.jpg?v=1788926710",
    },
    {
      title: "Locks",
      subtitle: "Your door, in the app.",
      price: "From $339",
      href: "/collections/locks",
      image:
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Locks_c273c8e6-44b1-4b4d-89aa-27fc683a3334.jpg?v=1788926710",
    },
    {
      title: "Accessories",
      subtitle: "The finishing pieces.",
      price: "From $8.90",
      href: "/collections/accessories-1",
      image:
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Accessories.jpg?v=1788926710",
    },
  ];

  const STORIES_TITLE = "Designed for local homes";

  // TODO: re-encode - these are 60-147MB each, ~420MB for the four.
  const STORY_VIDEOS = [
    {
      video:
        "https://cdn.shopify.com/videos/c/o/v/0441345ddc414fe6b88bdcb0c7631192.mp4",
      poster: "",
    },
    {
      video:
        "https://cdn.shopify.com/videos/c/o/v/20e27c68a0d647a8a1b07b8bd5b6c98e.mp4",
      poster: "",
    },
    {
      video:
        "https://cdn.shopify.com/videos/c/o/v/1c6f380fb16b482a8acafcfb39157d76.mp4",
      poster: "",
    },
    {
      video:
        "https://cdn.shopify.com/videos/c/o/v/1103d3c07e264316a20f86cade88072f.mp4",
      poster: "",
    },
  ];

  const TRUSTED_LABEL = "Trusted by";

  // Optional per-logo width / height (px) override the shared row height.
  const TRUSTED_LOGOS = [
    {
      name: "The Straits Times",
      image:
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/StraitsTimes.jpg?v=1788927851",
      width: "209",
      height: "50",
    },
    {
      name: "The Business Times",
      image:
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/BusinessTimes_9ea3683f-68a6-4002-a7b0-968c3b506d80.jpg?v=1788927851",
      width: "51",
      height: "42",
    },
    {
      name: "CNA",
      image:
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/8390cfc735b5e5fc977eceeb1f8f4fc34b3da306.png?v=1788854059",
      width: "43",
      height: "50",
    },
    {
      name: "Lianhe Zaobao",
      image:
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Lianhe_Zaobao_7e046707-6757-4f89-ad49-ae54ce17ca62.jpg?v=1788927851",
      width: "122",
      height: "76",
    },
    {
      name: "AsiaOne",
      image:
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/AsiaOne_665b2329-2999-494a-acac-79b7a575cc8e.jpg?v=1788927851",
      width: "87",
      height: "54",
    },
    {
      name: "Home & Decor",
      image:
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/HomeDecor_df7cb461-308f-4590-92e5-33f9c4ce4bf5.jpg?v=1788927851",
      width: "88",
      height: "54",
    },
    {
      name: "NYLON",
      image:
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/NYLON.png?v=1788927851",
      width: "97",
      height: "17",
    },
    {
      name: "Hardware Zone Singapore",
      image:
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/HardwareZone.jpg?v=1788927851",
      width: "86",
      height: "54",
    },
    {
      name: "CBON",
      image:
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/CBON.png?v=1788927851",
      width: "62",
      height: "62",
    },
    {
      name: "SuperAdrianMe",
      image:
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/SuperAdrian.png?v=1788927851",
      width: "62",
      height: "62",
    },
  ];

  const FOOTER_COLUMNS = [
    [
      { label: "Shop at PRISM+", heading: true },
      { label: "TV", href: "/collections/tvs" },
      { label: "Aircon", href: "/products/prism-neo" },
      { label: "Fan", href: "/collections/smart-ceiling-fans" },
      { label: "Fridge", href: "/collections/refrigerators" },
      { label: "Laundry", href: "/collections/laundry-appliances" },
      { label: "Vacuum", href: "/collections/vacuum" },
      { label: "Smart Lock", href: "/collections/locks" },
      { label: "Monitor", href: "/collections/gaming-monitors" },
      { label: "Air Purifier", href: "/collections/smart-air-purifiers" },
      { label: "Soundbar", href: "/collections/soundbar" },
      { label: "Accessories", href: "/collections/accessories-1" },
    ],
    [
      { label: "Company", heading: true },
      { label: "Careers", href: "/pages/career-page" },
      { label: "Blog", href: "/blogs/blog" },
      { label: "Community", href: "/pages/community" },
      { label: "For Business", heading: true },
      { label: "Corporate Enquiries", href: "/pages/business" },
      { label: "Partnerships", href: "/pages/partnerships-media-influencers" },
    ],
    [
      { label: "Support", heading: true },
      { label: "Find a Store", href: "https://prismplus.sg/pages/contact-us" },
      { label: "Contact", href: "/pages/contact-us" },
      {
        label: "Customer Care",
        href: "https://prismplus.my.site.com/customercare/s/",
      },
    ],
  ];

  const FOOTER_LEGAL_LINKS = [
    { label: "Privacy Policy", href: "/pages/privacy-policy" },
    { label: "Term of Services", href: "/pages/terms-of-service" },
  ];

  const FOOTER_REGION = "Singapore";

  // Declared before main() runs - `let` is not hoisted.
  let storyObserver = null;

  // Runs immediately, not on DOMContentLoaded, so the hide rule lands before
  // first paint.
  if (isHomepage()) {
    hideThemeSections();
    addFont();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", main);
  } else {
    main();
  }

  function main() {
    if (!isHomepage()) return;

    addStyles();
    mountRoot();
    initCompareModal();
    initCountdown();
    equalizePromoBodies();
    initCarousels();
    initFeatureVideos();
    initStoriesLoop();
    initTrustedMarquee();
    initStoryVideos();
  }

  function isHomepage() {
    return window.location.pathname.replace(/\/+$/, "") === "";
  }

  // display:none, not removal: the theme's own JS still queries these nodes.
  function hideThemeSections() {
    const style = document.createElement("style");
    style.id = "hpo-hide";
    style.textContent = `
      ${HIDDEN_SECTIONS.join(",\n      ")} {
        display: none !important;
      }
    `;
    (document.head || document.documentElement).appendChild(style);
  }

  function addFont() {
    const head = document.head || document.documentElement;

    const preconnect = document.createElement("link");
    preconnect.rel = "preconnect";
    preconnect.href = "https://fonts.gstatic.com";
    preconnect.crossOrigin = "anonymous";
    head.appendChild(preconnect);

    const font = document.createElement("link");
    font.id = "hpo-font";
    font.rel = "stylesheet";
    font.href = FONT_URL;
    head.appendChild(font);
  }

  function mountRoot() {
    if (document.getElementById(ROOT_ID)) return;

    const root = document.createElement("div");
    root.id = ROOT_ID;
    root.appendChild(buildBundleBar());

    root.appendChild(buildMain());
    root.appendChild(buildFooter());

    const anchor = document.querySelector(ANCHOR);
    if (anchor) {
      anchor.insertAdjacentElement("afterend", root);
    } else {
      // ANCHOR missing (theme changed?) - render anyway, then re-check ANCHOR.
      document.body.appendChild(root);
    }
  }

  function buildMain() {
    const main = document.createElement("main");
    main.id = "hpo-main";

    main.appendChild(buildHero());
    main.appendChild(buildShortcuts());
    // main.appendChild(buildPromos());
    main.appendChild(buildShowcase());
    main.appendChild(buildTrusted());
    main.appendChild(buildFeatures());
    main.appendChild(buildStories());
    main.appendChild(buildCategories());

    return main;
  }

  function buildHero() {
    const section = document.createElement("section");
    section.id = "hpo-hero";
    section.className = "hpo-section";

    if (HERO_IMAGE) section.style.backgroundImage = `url("${HERO_IMAGE}")`;

    const mobileImage = HERO_IMAGE_MOBILE || HERO_IMAGE;

    const logo = HERO_LOGO
      ? `<img class="hpo-hero-logo" src="${HERO_LOGO}" alt="">`
      : "";
    const eyebrow =
      HERO.eyebrow && !saleEnded()
        ? `<p class="hpo-hero-eyebrow"><span class="hpo-hero-dot" aria-hidden="true"></span><span>${HERO.eyebrow}</span></p>`
        : "";
    const actions = HERO.primary
      ? `<div class="hpo-hero-actions">
          <a class="hpo-btn hpo-btn--dark" href="${HERO.primary.href || "#"}">${HERO.primary.label}</a>
        </div>`
      : "";

    section.innerHTML = `
      ${mobileImage ? `<div class="hpo-hero-media"><img class="hpo-hero-image" src="${mobileImage}" alt="" fetchpriority="high"></div>` : ""}
      <div class="hpo-container hpo-hero-inner">
        ${eyebrow}
        <h1 class="hpo-hero-title">
          ${logo}${HERO.title}
        </h1>
        ${HERO.subtitle ? `<p class="hpo-hero-copy">${HERO.subtitle}</p>` : ""}
        ${actions}
      </div>
    `;

    return section;
  }

  function buildBundleBar() {
    const section = document.createElement("section");
    section.id = "hpo-bundle-bar";

    section.innerHTML = `
      <div class="hpo-container hpo-bundle-bar-inner">
        <span class="hpo-bundle-bar-text">${BUNDLE_BAR.text}</span>
        <span class="hpo-bundle-bar-text hpo-bundle-bar-text--mobile">${BUNDLE_BAR.textMobile}</span>
        <a class="hpo-bundle-bar-link" href="${BUNDLE_BAR.link.href || "#"}">${BUNDLE_BAR.link.label}</a>
      </div>
    `;

    return section;
  }

  function buildShortcuts() {
    const section = document.createElement("section");
    section.id = "hpo-shortcuts";
    section.className = "hpo-section";

    section.innerHTML = `
      <nav class="hpo-container hpo-shortcuts-row" aria-label="Shop by category">
        ${CATEGORY_SHORTCUTS.map(buildShortcut).join("")}
      </nav>
    `;

    return section;
  }

  function buildShortcut(item) {
    return `
      <a class="hpo-shortcut" href="${item.href || "#"}">
        <span class="hpo-shortcut-media">
          <img class="hpo-shortcut-image" src="${item.image}" alt="" loading="lazy">
        </span>
        <span class="hpo-shortcut-label">${item.label}</span>
      </a>
    `;
  }

  // ── promo section ───────────────────────────────────────────────────────

  function buildPromos() {
    const section = document.createElement("section");
    section.id = "hpo-promos";
    section.className = "hpo-section";
    section.setAttribute("data-hpo-carousel", "");

    const cards = PROMO_CARDS.map(buildPromoCard).join("");

    section.innerHTML = `
      <div class="hpo-container hpo-promos-head">
        <h2 class="hpo-section-title">${PROMO_TITLE}</h2>
        <p class="hpo-promos-countdown">Ends in <b data-hpo-countdown></b></p>
      </div>
      <div class="hpo-promos-carousel">
        <div class="hpo-promos-track" data-hpo-track>${cards}</div>
        <button class="hpo-carousel-nav hpo-carousel-nav--prev" type="button" data-hpo-prev aria-label="Previous">
          ${ICON_CHEVRON_LEFT}
        </button>
        <button class="hpo-carousel-nav hpo-carousel-nav--next" type="button" data-hpo-next aria-label="Next">
          ${ICON_CHEVRON_RIGHT}
        </button>
      </div>
    `;

    return section;
  }

  function buildPromoCard(card) {
    const bg = card.image
      ? ` style="background-image: url('${card.image}')"`
      : "";
    const button =
      card.theme === "dark" ? "hpo-btn--primary" : "hpo-btn--dark";

    return `
      <a class="hpo-promo hpo-promo--${card.theme}" href="${card.cta.href || "#"}"${bg}>
        <div class="hpo-promo-copy">
          <p class="hpo-promo-eyebrow">${card.eyebrow}</p>
          <h3 class="hpo-promo-title">${card.title}</h3>
          <p class="hpo-promo-body"><span>${card.body}</span></p>
          <p class="hpo-promo-price">${card.price}</p>
          <span class="hpo-btn ${button}">${card.cta.label}</span>
        </div>
      </a>
    `;
  }

  function equalizePromoBodies() {
    const bodies = document.querySelectorAll("#hpo-promos .hpo-promo-body");
    if (!bodies.length) return;

    const apply = () => {
      bodies.forEach((el) => (el.style.minHeight = ""));

      const tallest = Math.max(
        ...Array.from(bodies, (el) => el.getBoundingClientRect().height),
      );
      bodies.forEach((el) => (el.style.minHeight = `${Math.ceil(tallest)}px`));
    };

    apply();

    if (document.fonts && document.fonts.ready)
      document.fonts.ready.then(apply);

    let resizeTimer;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(apply, 150);
    });
  }

  // ── countdown ───────────────────────────────────────────────────────────

  function initCountdown() {
    const el = document.querySelector("[data-hpo-countdown]");
    if (!el) return;

    let timer = null;

    function tick() {
      const left = SALE_END.getTime() - Date.now();

      if (left <= 0) {
        if (timer) clearInterval(timer);
        const line = el.closest(".hpo-promos-countdown");
        if (line) line.remove();
        return;
      }

      el.textContent = formatCountdown(left);
    }

    tick();
    timer = setInterval(tick, 1000);
  }

  function formatCountdown(ms) {
    const total = Math.floor(ms / 1000);
    const days = Math.floor(total / 86400);
    const hours = Math.floor((total % 86400) / 3600);
    const minutes = Math.floor((total % 3600) / 60);
    const seconds = total % 60;

    return `${days}d ${hours}h ${minutes}m ${seconds}s`;
  }

  function saleEndLabel() {
    return SALE_END.toLocaleDateString("en-SG", {
      timeZone: "Asia/Singapore",
      day: "numeric",
      month: "long",
    });
  }

  function saleEnded() {
    return SALE_END.getTime() <= Date.now();
  }

  function initCarousels() {
    document.querySelectorAll("[data-hpo-carousel]").forEach(initCarousel);
  }

  function initCarousel(section) {
    const track = section.querySelector("[data-hpo-track]");
    const prev = section.querySelector("[data-hpo-prev]");
    const next = section.querySelector("[data-hpo-next]");
    if (!track || !prev || !next) return;

    const looping = track.hasAttribute("data-hpo-loop");

    const step = () => {
      const card = track.firstElementChild;
      if (!card) return track.clientWidth;

      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;

      return card.offsetWidth + gap;
    };

    prev.addEventListener("click", () => {
      track.scrollBy({ left: -step(), behavior: "smooth" });
    });
    next.addEventListener("click", () => {
      track.scrollBy({ left: step(), behavior: "smooth" });
    });

    const updateArrows = () => {
      if (looping) return;

      const maxScroll = track.scrollWidth - track.clientWidth;
      prev.hidden = track.scrollLeft <= 1;
      next.hidden = track.scrollLeft >= maxScroll - 1;
    };

    track.addEventListener("scroll", updateArrows, { passive: true });
    window.addEventListener("resize", updateArrows);
    updateArrows();

    if (looping) initLoop(track);
  }

  // Endless scroll: three identical card sets, and scrolling into either outer
  // set silently jumps back to the middle one.
  function initLoop(track) {
    const active = () => track.hasAttribute("data-hpo-loop");

    const setWidth = () => {
      const cards = track.children;
      const perSet = cards.length / 3;

      return cards[perSet] ? cards[perSet].offsetLeft - cards[0].offsetLeft : 0;
    };

    const recentre = () => {
      if (!active()) return;

      const width = setWidth();
      if (width > 0) track.scrollLeft = width;
    };

    const normalise = () => {
      if (!active()) return;

      const width = setWidth();
      if (width <= 0) return;

      let guard = 5;
      while (track.scrollLeft < width * 0.5 && guard--)
        track.scrollLeft += width;

      guard = 5;
      while (track.scrollLeft >= width * 1.5 && guard--)
        track.scrollLeft -= width;
    };

    let touched = false;
    ["pointerdown", "touchstart", "wheel", "keydown"].forEach((evt) =>
      track.addEventListener(evt, () => (touched = true), {
        once: true,
        passive: true,
      }),
    );

    const settleStart = () => {
      if (!touched) recentre();
    };

    recentre();
    requestAnimationFrame(settleStart);
    setTimeout(settleStart, 300);
    window.addEventListener("load", settleStart);

    let settle;
    track.addEventListener(
      "scroll",
      () => {
        clearTimeout(settle);
        settle = setTimeout(normalise, 120);
      },
      { passive: true },
    );

    let resized;
    window.addEventListener("resize", () => {
      clearTimeout(resized);
      resized = setTimeout(recentre, 150);
    });
  }

  function buildTrusted() {
    const section = document.createElement("section");
    section.id = "hpo-trusted";
    section.className = "hpo-section";

    const logos = TRUSTED_LOGOS.map(
      (logo) => `
        <div class="hpo-trusted-logo"${logoSize(logo)}>
          ${
            logo.image
              ? `<img src="${logo.image}" alt="${logo.name}" loading="lazy">`
              : `<span class="hpo-trusted-placeholder">${logo.name}</span>`
          }
        </div>
      `,
    ).join("");

    section.innerHTML = `
      <div class="hpo-container">
        <p class="hpo-trusted-label">${TRUSTED_LABEL}</p>
        <div class="hpo-trusted-row">
          <div class="hpo-trusted-track">${logos}</div>
        </div>
      </div>
    `;

    return section;
  }

  function logoSize(logo) {
    const vars = [
      logo.width ? `--hpo-logo-w:${logo.width}px` : "",
      logo.height ? `--hpo-logo-h:${logo.height}px` : "",
      logo.width || logo.height ? "--hpo-logo-shrink:0" : "",
    ].filter(Boolean);

    return vars.length ? ` style="${vars.join(";")}"` : "";
  }

  function buildFeatures() {
    const section = document.createElement("section");
    section.id = "hpo-features";
    section.className = "hpo-section";

    section.innerHTML = `
      <div class="hpo-features-grid">
        ${FEATURE_CARDS.map(buildFeatureCard).join("")}
      </div>
    `;

    return section;
  }

  function buildShowcase() {
    const section = document.createElement("section");
    section.id = "hpo-showcase";
    section.className = "hpo-section";

    if (SHOWCASE.background) {
      section.style.backgroundImage = `url("${SHOWCASE.background}")`;
    }

    section.innerHTML = `
      <div class="hpo-container hpo-showcase-head">
        <h2 class="hpo-section-title">${SHOWCASE.title}</h2>
        <p class="hpo-showcase-subtitle">${SHOWCASE.subtitle}</p>
        <div class="hpo-showcase-actions">
          <a class="hpo-btn hpo-btn--primary" href="${SHOWCASE.primary.href || "#"}">${SHOWCASE.primary.label}</a>
          <a class="hpo-btn hpo-btn--secondary" href="${SHOWCASE.secondary.href || "#"}" data-hpo-compare>${SHOWCASE.secondary.label}</a>
        </div>
      </div>
      <div class="hpo-showcase-grid">
        ${SHOWCASE.products.map(buildShowcaseProduct).join("")}
      </div>
    `;

    return section;
  }

  // Prefetches on hover / touch / focus so the popup is ready by the click.
  function initCompareModal() {
    const trigger = document.querySelector("[data-hpo-compare]");
    if (!trigger) return;

    let loading = null;

    const warm = () => {
      loading = loading || loadComparePopup();

      return loading;
    };

    ["pointerenter", "touchstart", "focus"].forEach((type) =>
      trigger.addEventListener(type, warm, { once: true, passive: true }),
    );

    trigger.addEventListener("click", (e) => {
      e.preventDefault();

      const existing = document.querySelector(".tv_compare_popup");
      if (existing) return openComparePopup(existing);

      trigger.setAttribute("aria-busy", "true");

      warm()
        .then((popup) => {
          trigger.removeAttribute("aria-busy");
          if (popup) return openComparePopup(popup);

          window.location.href = COMPARE_PAGE_URL;
        })
        .catch(() => {
          trigger.removeAttribute("aria-busy");
          window.location.href = COMPARE_PAGE_URL;
        });
    });
  }

  function openComparePopup(popup) {
    const header = document.getElementById("shopify-section-header");
    const offset = header
      ? Math.round(header.getBoundingClientRect().height)
      : 44;
    popup.style.setProperty("top", `${offset}px`, "important");

    popup.classList.add("active");
    document.body.style.overflow = "hidden";
  }

  function loadComparePopup() {
    return fetchComparePopup(COMPARE_SECTION_URL)
      .catch(() => null)
      .then((popup) => popup || fetchComparePopup(COMPARE_PAGE_URL));
  }

  // Plain fetch, no init object: Shopify's Web Pixels wrapper around fetch
  // throws "Failed to fetch" on options it does not expect.
  function fetchComparePopup(url) {
    return fetch(url)
      .then((res) => (res.ok ? res.text() : ""))
      .then((html) => {
        if (!html) return null;

        const parsed = new DOMParser().parseFromString(html, "text/html");
        const popup = parsed.querySelector(".tv_compare_popup");
        if (!popup) return null;

        const section = popup.closest(".shopify-section") || parsed.body;

        section.querySelectorAll('link[rel="stylesheet"]').forEach((link) => {
          if (
            document.querySelector(`link[href="${link.getAttribute("href")}"]`)
          )
            return;

          const copy = document.createElement("link");
          copy.rel = "stylesheet";
          copy.href = link.getAttribute("href");
          document.head.appendChild(copy);
        });

        document.body.appendChild(section);

        // Hidden: the section also carries the theme's own "Compare TVs" buttons,
        // which would otherwise end up stranded at the foot of the homepage.
        section.style.setProperty("display", "none", "important");

        section
          .querySelectorAll(".tv_compare_popup_close_btn")
          .forEach((button) =>
            button.addEventListener("click", () => {
              document.body.style.overflow = "";
            }),
          );

        return loadCompareScript().then(() => {
          // If tv-compare.js did not run, lift the popup out of the hidden section.
          if (section.contains(popup)) document.body.prepend(popup);

          return popup;
        });
      });
  }

  function loadCompareScript() {
    const src = themeAssetUrl(COMPARE_SCRIPT);
    if (!src || document.querySelector(`script[src="${src}"]`)) {
      return Promise.resolve();
    }

    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = resolve;
      script.onerror = resolve;
      document.head.appendChild(script);
    });
  }

  // Builds the URL off a theme asset this page already loaded, so it follows
  // the theme's /cdn/shop/t/NN/assets/ folder through a publish.
  function themeAssetUrl(file) {
    const asset = Array.from(
      document.querySelectorAll("script[src], link[href]"),
      (el) => el.getAttribute("src") || el.getAttribute("href"),
    ).find((url) => /\/cdn\/shop\/t\/\d+\/assets\//.test(url));

    return asset ? asset.replace(/\/assets\/.*$/, `/assets/${file}`) : "";
  }

  function buildShowcaseProduct(product) {
    const image = product.image
      ? `<img class="hpo-tv-image" src="${product.image}" alt="${product.name}" loading="lazy">`
      : "";

    return `
      <article class="hpo-tv">
        <div class="hpo-tv-copy">
          <h3 class="hpo-tv-name">${product.name}</h3>
          <p class="hpo-tv-spec">${product.spec}</p>
          <p class="hpo-tv-price">${product.price}</p>
          <a class="hpo-btn hpo-btn--primary" href="${product.href || "#"}">Shop Now</a>
        </div>
        ${image}
      </article>
    `;
  }

  function buildFeatureCard(card) {
    // Custom properties rather than background-image, so the mobile block can
    // swap the art; only the one that applies gets downloaded.
    const images = [
      card.image && `--hpo-feature-bg: url('${card.image}')`,
      card.imageMobile && `--hpo-feature-bg-mobile: url('${card.imageMobile}')`,
    ].filter(Boolean);
    const bg =
      images.length && !card.video ? ` style="${images.join("; ")}"` : "";
    const dark = card.theme === "dark";
    const variant = card.video ? " hpo-feature--video" : "";

    const secondary = card.secondary
      ? `<a class="hpo-btn ${dark ? "hpo-btn--secondary" : "hpo-btn--outline-dark"}" href="${card.secondary.href || "#"}">${card.secondary.label}</a>`
      : "";

    const video = card.video
      ? `<video class="hpo-feature-video" src="${card.video}"${card.image ? ` poster="${card.image}"` : ""}
           autoplay muted loop playsinline preload="auto" tabindex="-1" aria-hidden="true"></video>`
      : "";

    return `
      <article class="hpo-feature hpo-feature--${card.theme}${variant}"${bg}>
        <div class="hpo-feature-copy">
          <h3 class="hpo-feature-title">${card.title}</h3>
          <p class="hpo-feature-subtitle">${card.subtitle}</p>
          <p class="hpo-feature-price">
            ${card.price}
            ${card.was ? `<s class="hpo-feature-was">${card.was}</s>` : ""}
          </p>
          <div class="hpo-feature-actions">
            <a class="hpo-btn ${dark ? "hpo-btn--primary" : "hpo-btn--dark"}" href="${card.primary.href || "#"}">${card.primary.label}</a>
            ${secondary}
          </div>
        </div>
        ${video}
      </article>
    `;
  }

  function initFeatureVideos() {
    document.querySelectorAll(".hpo-feature-video").forEach((video) => {
      video.muted = true;
      const played = video.play();
      if (played && played.catch) played.catch(() => {});
    });
  }

  function buildStories() {
    const section = document.createElement("section");
    section.id = "hpo-stories";
    section.className = "hpo-section";

    const items = STORY_VIDEOS.map(
      (item) => `
        <div class="hpo-story">
          <video
            class="hpo-story-video"
            ${item.video ? `src="${storySrc(item)}"` : ""}
            ${item.poster ? `poster="${item.poster}"` : ""}
            loop
            muted
            playsinline
            preload="metadata"
          ></video>
        </div>
      `,
    ).join("");

    section.innerHTML = `
      <div class="hpo-container">
        <h2 class="hpo-section-title">${STORIES_TITLE}</h2>
        <div class="hpo-stories-grid">${items}</div>
      </div>
    `;

    return section;
  }

  // #t=0.1 makes the browser paint a first frame, so no poster is needed.
  function storySrc(item) {
    return item.poster ? item.video : `${item.video}#t=0.1`;
  }

  function initStoriesLoop() {
    const track = document.querySelector("#hpo-stories .hpo-stories-grid");
    if (!track) return;

    const mobile = window.matchMedia("(max-width: 749px)");
    const originals = Array.from(track.children);

    const addClones = () => {
      if (track.hasAttribute("data-hpo-loop")) return;

      originals.forEach((tile) => track.appendChild(cloneTile(tile)));
      originals
        .slice()
        .reverse()
        .forEach((tile) =>
          track.insertBefore(cloneTile(tile), track.firstChild),
        );

      track.setAttribute("data-hpo-loop", "");
      initStoryVideos();
    };

    const removeClones = () => {
      if (!track.hasAttribute("data-hpo-loop")) return;

      track.removeAttribute("data-hpo-loop");
      track.querySelectorAll("[data-hpo-clone]").forEach((el) => el.remove());
      track.scrollLeft = 0;
    };

    const sync = () => (mobile.matches ? addClones() : removeClones());

    sync();
    initLoop(track);
    mobile.addEventListener("change", sync);
  }

  function cloneTile(tile) {
    const clone = tile.cloneNode(true);
    clone.setAttribute("data-hpo-clone", "");
    clone.setAttribute("aria-hidden", "true");

    const video = clone.querySelector("video");
    if (video) video.tabIndex = -1;

    return clone;
  }

  function initTrustedMarquee() {
    const track = document.querySelector("#hpo-trusted .hpo-trusted-track");
    if (!track) return;

    const mobile = window.matchMedia("(max-width: 749px)");
    const originals = Array.from(track.children);

    const sync = () => {
      const duplicated = track.hasAttribute("data-hpo-marquee");

      if (mobile.matches && !duplicated) {
        originals.forEach((logo) => track.appendChild(cloneTile(logo)));
        track.setAttribute("data-hpo-marquee", "");
      } else if (!mobile.matches && duplicated) {
        track.removeAttribute("data-hpo-marquee");
        track
          .querySelectorAll("[data-hpo-clone]")
          .forEach((el) => el.remove());
      }
    };

    sync();
    mobile.addEventListener("change", sync);
  }

  function initStoryVideos() {
    const canHover = window.matchMedia("(hover: hover)").matches;
    const autoplay = window.matchMedia("(max-width: 749px)").matches;

    if (autoplay && !storyObserver && "IntersectionObserver" in window) {
      storyObserver = new IntersectionObserver(onStoryVisible, {
        threshold: 0.5,
      });
    }

    document
      .querySelectorAll("#hpo-stories .hpo-story-video")
      .forEach((video) => {
        if (video.dataset.hpoBound) return;
        video.dataset.hpoBound = "1";

        if (canHover) {
          video.addEventListener("mouseenter", () => playWithSound(video));

          video.addEventListener("mouseleave", () => {
            video.pause();
            video.muted = true;
          });
        }

        video.addEventListener("click", () => {
          if (autoplay) return toggleStorySound(video);

          if (!video.paused) return video.pause();

          pauseOtherStories(video);
          playWithSound(video);
        });

        if (storyObserver) storyObserver.observe(video);
      });
  }

  function onStoryVisible(entries) {
    entries.forEach((entry) => {
      const video = entry.target;

      if (entry.isIntersecting) {
        const played = video.play();
        if (played && played.catch) played.catch(() => {});

        return;
      }

      video.pause();
      video.muted = true;
    });
  }

  function toggleStorySound(video) {
    if (!video.muted) {
      video.muted = true;

      return;
    }

    document
      .querySelectorAll("#hpo-stories .hpo-story-video")
      .forEach((other) => {
        if (other !== video) other.muted = true;
      });

    video.muted = false;

    const played = video.play();
    if (!played || !played.catch) return;

    played.catch(() => {
      video.muted = true;
      const retry = video.play();
      if (retry && retry.catch) retry.catch(() => {});
    });
  }

  function pauseOtherStories(current) {
    document
      .querySelectorAll("#hpo-stories .hpo-story-video")
      .forEach((video) => {
        if (video === current) return;

        video.pause();
        video.muted = true;
      });
  }

  function playWithSound(video) {
    video.muted = false;

    const played = video.play();
    if (!played || !played.catch) return;

    played.catch(() => {
      video.muted = true;
      const retry = video.play();
      if (retry && retry.catch) retry.catch(() => {});
    });
  }

  function buildCategories() {
    const section = document.createElement("section");
    section.id = "hpo-categories";
    section.className = "hpo-section";
    section.setAttribute("data-hpo-carousel", "");

    const cards = CATEGORY_CARDS.map((card) => buildCategoryCard(card)).join(
      "",
    );
    const clones = CATEGORY_CARDS.map((card) =>
      buildCategoryCard(card, true),
    ).join("");

    section.innerHTML = `
      <div class="hpo-container">
        <h2 class="hpo-section-title">${CATEGORIES_TITLE}</h2>
      </div>
      <div class="hpo-categories-carousel">
        <div class="hpo-categories-track" data-hpo-track data-hpo-loop>
          ${clones}${cards}${clones}
        </div>
        <button class="hpo-carousel-nav hpo-carousel-nav--prev" type="button" data-hpo-prev aria-label="Previous">
          ${ICON_CHEVRON_LEFT}
        </button>
        <button class="hpo-carousel-nav hpo-carousel-nav--next" type="button" data-hpo-next aria-label="Next">
          ${ICON_CHEVRON_RIGHT}
        </button>
      </div>
    `;

    return section;
  }

  function buildCategoryCard(card, isClone) {
    const bg = card.image
      ? ` style="background-image: url('${card.image}')"`
      : "";
    const hidden = isClone ? ` aria-hidden="true" tabindex="-1"` : "";

    const image = card.image
      ? `<img class="hpo-category-image" src="${card.image}" alt="" loading="lazy">`
      : "";

    return `
      <a class="hpo-category" href="${card.href || "#"}"${bg}${hidden}>
        ${image}
        <div class="hpo-category-copy">
          <h3 class="hpo-category-title">${card.title}</h3>
          ${card.subtitle ? `<p class="hpo-category-subtitle">${card.subtitle}</p>` : ""}
          <p class="hpo-category-price">${card.price}</p>
        </div>
      </a>
    `;
  }

  function buildFooter() {
    const footer = document.createElement("footer");
    footer.id = "hpo-footer";

    footer.innerHTML = `
      <div class="hpo-container">
        ${buildFooterTop()}
        ${buildFooterSocial()}
        ${buildFooterBottom()}
      </div>
    `;

    return footer;
  }

  function buildFooterTop() {
    const columns = FOOTER_COLUMNS.map((items) => {
      const rows = items
        .map((item) =>
          item.heading
            ? `<li class="hpo-footer-heading">${item.label}</li>`
            : `<li><a class="hpo-footer-link" href="${item.href || "#"}">${item.label}</a></li>`,
        )
        .join("");

      return `<ul class="hpo-footer-col">${rows}</ul>`;
    }).join("");

    const apps = APP_LINKS.map(
      (app) => `
        <a class="hpo-footer-app-badge" href="${app.href}" target="_blank" rel="noopener">
          <img src="${app.image}" alt="${app.label}" loading="lazy">
        </a>
      `,
    ).join("");

    return `
      <div class="hpo-footer-top">
        <div class="hpo-footer-links">${columns}</div>
        <div class="hpo-footer-app">
          <p class="hpo-footer-app-title">Download the PRISM+ Connect App</p>
          <div class="hpo-footer-app-badges">${apps}</div>
        </div>
      </div>
    `;
  }

  function buildFooterSocial() {
    const icons = SOCIAL_LINKS.map(
      (social) => `
        <a class="hpo-social-btn" href="${social.href || "#"}" aria-label="${social.label}">
          ${social.icon}
        </a>
      `,
    ).join("");

    return `<div class="hpo-footer-social">${icons}</div>`;
  }

  function buildFooterBottom() {
    const links = FOOTER_LEGAL_LINKS.map(
      (link) => `<a href="${link.href || "#"}">${link.label}</a>`,
    ).join('<span class="hpo-footer-divider">|</span>');

    const copyright = `Copyright &copy; ${new Date().getFullYear()} PRISM+. All Rights Reserved.`;

    return `
      <div class="hpo-footer-bottom">
        <p class="hpo-footer-copyright">${copyright}</p>
        <p class="hpo-footer-copyright hpo-footer-copyright--mobile">${copyright} ${FOOTER_REGION}.</p>
        <p class="hpo-footer-legal-links">${links}</p>
        <p class="hpo-footer-region">${FOOTER_REGION}</p>
      </div>
    `;
  }

  function addStyles() {
    const style = document.createElement("style");
    style.id = "hpo-styles";
    style.textContent = `
      /* ── scoped reset: neutralises the theme's global element styles ── */
      #${ROOT_ID},
      #${ROOT_ID} * ,
      #${ROOT_ID} *::before,
      #${ROOT_ID} *::after {
        box-sizing: border-box;
      }
      #${ROOT_ID} h1,
      #${ROOT_ID} h2,
      #${ROOT_ID} h3,
      #${ROOT_ID} h4,
      #${ROOT_ID} h5,
      #${ROOT_ID} h6,
      #${ROOT_ID} p,
      #${ROOT_ID} ul,
      #${ROOT_ID} ol,
      #${ROOT_ID} li,
      #${ROOT_ID} span,
      #${ROOT_ID} strong,
      #${ROOT_ID} b,
      #${ROOT_ID} em,
      #${ROOT_ID} i,
      #${ROOT_ID} small,
      #${ROOT_ID} figure {
        margin: 0;
        padding: 0;
        font: inherit;
        color: inherit;
        letter-spacing: normal;
        text-transform: none;
      }
      #${ROOT_ID} ul,
      #${ROOT_ID} ol {
        list-style: none;
      }
      #${ROOT_ID} a {
        color: inherit;
        text-decoration: none;
        border: 0;
      }
      /* Undo the theme's link hover/focus styles; !important to beat theirs. */
      #${ROOT_ID} a:hover,
      #${ROOT_ID} a:focus,
      #${ROOT_ID} a:active {
        opacity: 1;
      }
      #${ROOT_ID} a:focus,
      #${ROOT_ID} a:active {
        color: inherit !important;
        text-decoration: none;
      }
      #${ROOT_ID} .hpo-btn:focus,
      #${ROOT_ID} .hpo-btn:active {
        color: var(--hpo-btn-fg, inherit) !important;
      }
      #${ROOT_ID} a:focus-visible,
      #${ROOT_ID} button:focus-visible {
        outline: 2px solid currentColor;
        outline-offset: 2px;
      }
      #${ROOT_ID} img,
      #${ROOT_ID} svg,
      #${ROOT_ID} video {
        display: block;
        max-width: 100%;
        height: auto;
      }
      #${ROOT_ID} button {
        font: inherit;
        color: inherit;
        background: none;
        border: 0;
        padding: 0;
        cursor: pointer;
      }

      #${ROOT_ID} {
        --hpo-header-bg: #282829;
        --hpo-header-h: 44px;
        --hpo-feature-h: 500px;
        --hpo-ink: #111;
        --hpo-muted: #666;
        --hpo-line: #28282999;
        --hpo-bg: #FFF;
        --hpo-band: #171513;
        --hpo-band-0: rgba(23, 21, 19, 0);
        --hpo-live-dot: #E01F26;
        --hpo-font: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI",
          Roboto, Helvetica, Arial, sans-serif;
        --hpo-max: 2560px;
        --hpo-max-secondary: 1440px;
        --hpo-gutter: 20px;

        font-family: var(--hpo-font);
        color: var(--hpo-ink);
        -webkit-font-smoothing: antialiased;
        background: var(--hpo-bg);
        font-size: 16px;
        line-height: normal;
      }
      #${ROOT_ID} .hpo-container {
        width: 100%;
        max-width: var(--hpo-max);
        margin: 0 auto;
        padding: 0 var(--hpo-gutter);
      }
      #${ROOT_ID} .hpo-section {
        padding: 24px 0;
      }
      #${ROOT_ID} .hpo-section-title {
        font-size: 30px;
        font-weight: 600;
        text-align: center;
        margin-bottom: 28px;
      }
      #${ROOT_ID} .hpo-btn {
        color: var(--hpo-btn-fg, inherit);
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 12px 20px;
        border-radius: 44px;
        font-size: 16px;
        font-weight: 500;
        white-space: nowrap;
        transition: background-color 0.15s ease, color 0.15s ease;
      }
      #${ROOT_ID} .hpo-btn--primary {
        background: #FFFFFF;
        --hpo-btn-fg: var(--hpo-header-bg);
      }
      #${ROOT_ID} .hpo-btn--primary:hover {
        background: rgba(255, 255, 255, 0.88);
      }
      #${ROOT_ID} .hpo-btn[aria-busy="true"] {
        cursor: progress;
        opacity: 0.7;
      }
      #${ROOT_ID} .hpo-btn--dark {
        background: var(--hpo-header-bg);
        --hpo-btn-fg: #FFFFFF;
      }
      #${ROOT_ID} .hpo-btn--dark:hover {
        background: #3d3d3f;
      }
      #${ROOT_ID} .hpo-btn--outline-dark {
        background: transparent;
        --hpo-btn-fg: var(--hpo-header-bg);
        border: 1px solid var(--hpo-header-bg);
      }
      #${ROOT_ID} .hpo-btn--outline-dark:hover {
        background: rgba(40, 40, 41, 0.08);
      }
      #${ROOT_ID} .hpo-btn--secondary {
        background: transparent;
        --hpo-btn-fg: #FFFFFF;
        border: 1px solid #FFFFFF;
      }
      #${ROOT_ID} .hpo-btn--secondary:hover {
        background: rgba(255, 255, 255, 0.14);
      }

      #${ROOT_ID} #hpo-hero {
        --hpo-hero-h: 600px;
        position: relative;
        display: flex;
        align-items: flex-start;
        height: var(--hpo-hero-h);
        padding: 24px 0;
        background-color: #0B0B0B;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        color: #FFFFFF;
        text-align: center;
      }
      #hpo-hero .hpo-hero-eyebrow {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 10px;
      }
      #hpo-hero .hpo-hero-dot {
        position: relative;
        flex: 0 0 auto;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: var(--hpo-live-dot);
      }
      #hpo-hero .hpo-hero-dot::after {
        content: "";
        position: absolute;
        inset: 0;
        border-radius: 50%;
        background: var(--hpo-live-dot);
        animation: hpo-hero-dot-pulse 1.8s ease-out infinite;
      }
      @keyframes hpo-hero-dot-pulse {
        0% {
          transform: scale(1);
          opacity: 0.7;
        }
        70% {
          opacity: 0;
        }
        100% {
          transform: scale(3.2);
          opacity: 0;
        }
      }
      @media (prefers-reduced-motion: reduce) {
        #hpo-hero .hpo-hero-dot::after {
          display: none;
        }
      }
      #hpo-hero .hpo-hero-logo {
        flex: 0 0 auto;
        height: 0.95em;
        width: auto;
        max-width: none;
      }

      #hpo-hero .hpo-hero-media {
        display: none;
      }
      #hpo-hero::before {
        content: "";
        position: absolute;
        inset: 0;
        background: linear-gradient(
          to bottom,
          rgba(0, 0, 0, 0.75) 0%,
          rgba(0, 0, 0, 0) 60%
        );
        pointer-events: none;
      }
      #hpo-hero .hpo-hero-inner {
        position: relative;
        z-index: 1;
      }
      #hpo-hero .hpo-hero-title {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 12px;
        font-size: 46px;
        font-weight: 700;
        margin-bottom: 12px;
      }
      #hpo-hero .hpo-hero-copy {
        font-size: 20px;
        margin-bottom: 24px;
      }
      #hpo-hero .hpo-hero-actions {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 16px;
        flex-wrap: wrap;
      }

      #${ROOT_ID} .hpo-carousel-nav {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        z-index: 2;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 48px;
        height: 48px;
        border-radius: 50%;
        background: #DDDDDDCC;
        color: var(--hpo-header-bg);
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.18);
        backdrop-filter: blur(2px);
        transition: background-color 0.15s ease;
      }
      #${ROOT_ID} .hpo-carousel-nav[hidden] {
        display: none;
      }
      #${ROOT_ID} .hpo-carousel-nav:hover {
        background: #DDDDDD;
      }
      #${ROOT_ID} .hpo-carousel-nav svg {
        width: 22px;
        height: 22px;
      }
      #${ROOT_ID} .hpo-carousel-nav--prev {
        left: 24px;
      }
      #${ROOT_ID} .hpo-carousel-nav--next {
        right: 24px;
      }

      #${ROOT_ID} #hpo-trusted {
        --hpo-max: var(--hpo-max-secondary);
      }
      #${ROOT_ID} #hpo-trusted {
        padding: 64px 0;
      }
      #hpo-trusted .hpo-trusted-label {
        font-size: 20px;
        font-weight: 500;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        color: var(--hpo-header-bg);
        margin-bottom: 28px;
      }
      #hpo-trusted .hpo-trusted-row {
        overflow: hidden;
      }
      #hpo-trusted .hpo-trusted-track {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: nowrap;
        gap: 10px;
      }
      #hpo-trusted .hpo-trusted-logo {
        flex: 0 var(--hpo-logo-shrink, 1) auto;
        min-width: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        height: var(--hpo-logo-h, 76px);
      }
      #hpo-trusted .hpo-trusted-logo img {
        width: var(--hpo-logo-w, auto);
        height: var(--hpo-logo-h, auto);
        max-width: var(--hpo-logo-w, 100%);
        max-height: var(--hpo-logo-h, 100%);
        object-fit: contain;
      }
      #hpo-trusted .hpo-trusted-placeholder {
        display: flex;
        align-items: center;
        justify-content: center;
        width: auto;
        min-width: 64px;
        height: 100%;
        padding: 0 12px;
        border: 1px dashed var(--hpo-line);
        font-size: 12px;
        color: var(--hpo-muted);
        text-align: center;
      }

      #hpo-features .hpo-features-grid {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 24px;
        padding: 0 24px;
      }
      #${ROOT_ID} .hpo-feature {
        position: relative;
        min-height: var(--hpo-feature-h);
        overflow: hidden;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        text-align: center;
      }
      #${ROOT_ID} .hpo-feature:not(.hpo-feature--video) {
        background-image: var(--hpo-feature-bg, none);
        background-size: contain;
        background-position: center bottom;
      }
      #${ROOT_ID} .hpo-feature--video {
        display: flex;
        flex-direction: column;
      }
      #${ROOT_ID} .hpo-feature-video {
        flex: 1 1 auto;
        min-height: 0;
        width: 100%;
        max-width: 250px;
        margin: 0 auto;
        object-fit: cover;
        object-position: center;
        pointer-events: none;
      }
      #${ROOT_ID} .hpo-feature--video::before {
        display: none;
      }
      #${ROOT_ID} .hpo-feature::before {
        content: "";
        position: absolute;
        inset: 0;
        z-index: 1;
        pointer-events: none;
      }
      #${ROOT_ID} .hpo-feature--dark {
        background-color: #000000;
        color: #FFFFFF;
      }
      #${ROOT_ID} .hpo-feature--dark::before {
        background: linear-gradient(
          to bottom,
          #000000 0%,
          rgba(0, 0, 0, 0) 50%
        );
      }
      #${ROOT_ID} .hpo-feature--light {
        background-color: #FFFFFF;
        color: var(--hpo-header-bg);
      }
      #${ROOT_ID} .hpo-feature--light::before {
        background: linear-gradient(
          to bottom,
          #FFFFFF 0%,
          rgba(255, 255, 255, 0) 50%
        );
      }
      #${ROOT_ID} .hpo-feature-copy {
        position: relative;
        z-index: 2;
        padding: 32px 24px 0;
      }
      #${ROOT_ID} .hpo-feature-title {
        font-size: 30px;
        font-weight: 700;
        margin-bottom: 12px;
      }
      #${ROOT_ID} .hpo-feature-subtitle {
        font-size: 20px;
        margin-bottom: 12px;
      }
      #${ROOT_ID} .hpo-feature-price {
        font-size: 16px;
        margin-bottom: 12px;
      }
      #${ROOT_ID} .hpo-feature-was {
        margin-left: 6px;
        color: #A4A4A4;
        text-decoration: line-through;
      }
      #${ROOT_ID} .hpo-feature-actions {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 20px;
        flex-wrap: wrap;
      }

      #${ROOT_ID} #hpo-showcase {
        --hpo-max: var(--hpo-max-secondary);
      }
      #${ROOT_ID} #hpo-showcase {
        background-color: #0A0A12;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        color: #FFFFFF;
      }
      #hpo-showcase .hpo-showcase-head {
        text-align: center;
      }
      #hpo-showcase .hpo-section-title {
        margin-bottom: 8px;
      }
      #hpo-showcase .hpo-showcase-subtitle {
        font-size: 20px;
        margin-bottom: 24px;
      }
      #hpo-showcase .hpo-showcase-actions {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 12px;
        flex-wrap: wrap;
        margin-bottom: 24px;
      }
      #hpo-showcase .hpo-showcase-grid {
        display: grid;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        grid-auto-rows: 1fr;
        gap: 24px;
        max-width: var(--hpo-max);
        margin: 0 auto;
        padding: 0 24px;
      }
      #hpo-showcase .hpo-tv {
        display: flex;
        flex-direction: column;
        overflow: hidden;
        background: #000000;
        text-align: center;
      }
      #hpo-showcase .hpo-tv-copy {
        flex: 1;
        display: flex;
        flex-direction: column;
        padding: 24px 16px 0;
      }
      #hpo-showcase .hpo-tv-copy .hpo-btn {
        margin-top: auto;
        align-self: center;
      }
      #hpo-showcase .hpo-tv-name {
        font-size: 24px;
        font-weight: 600;
        margin-bottom: 12px;
      }
      #hpo-showcase .hpo-tv-spec {
        font-size: 16px;
        margin-bottom: 12px;
      }
      #hpo-showcase .hpo-tv-price {
        font-size: 16px;
        margin-bottom: 12px;
      }
      #hpo-showcase .hpo-tv-image {
        flex: 0 0 auto;
        width: 100%;
        height: auto;
        max-width: 100%;
      }

      #${ROOT_ID} #hpo-categories {
        --hpo-gutter: 24px;
      }
      #hpo-categories .hpo-categories-carousel {
        position: relative;
        padding: 0 24px;
      }
      /* Scroll anchoring breaks the endless loop. */
      #${ROOT_ID} [data-hpo-loop] {
        overflow-anchor: none;
      }
      #hpo-categories .hpo-categories-track {
        display: flex;
        gap: 20px;
        overflow-x: auto;
        overflow-y: hidden;
        scroll-snap-type: x mandatory;
        /* Used for BOTH padding-left and scroll-padding-left: if they
           differ, the first card loads clipped. */
        --hpo-track-pad: max(
          var(--hpo-gutter),
          calc((100% - var(--hpo-max)) / 2 + var(--hpo-gutter))
        );
        scroll-padding-left: var(--hpo-track-pad);
        padding: 12px var(--hpo-track-pad);
        margin-block: -12px;
        scrollbar-width: none;
        -ms-overflow-style: none;
      }
      #hpo-categories .hpo-categories-track::-webkit-scrollbar {
        display: none;
      }
      #hpo-categories .hpo-category {
        position: relative;
        flex: 0 0 360px;
        height: 260px;
        overflow: hidden;
        scroll-snap-align: start;
        background-color: #000000;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        color: #FFFFFF;
      }
      @media (hover: hover) {
        #hpo-categories .hpo-category {
          transition: transform 0.25s ease;
        }
        #hpo-categories .hpo-category:hover {
          transform: scale(1.04);
          z-index: 1;
        }
        @media (prefers-reduced-motion: reduce) {
          #hpo-categories .hpo-category {
            transition: none;
          }
        }
      }

      #hpo-categories .hpo-category-image {
        display: none;
      }
      #hpo-categories .hpo-category::before {
        content: "";
        position: absolute;
        inset: 0;
        background: linear-gradient(
          to top,
          rgba(0, 0, 0, 0.85) 0%,
          rgba(0, 0, 0, 0) 60%
        );
        pointer-events: none;
      }
      #hpo-categories .hpo-category-copy {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1;
        padding: 20px;
      }
      #hpo-categories .hpo-category-title {
        font-size: 24px;
        font-weight: 600;
        margin-bottom: 4px;
      }
      #hpo-categories .hpo-category-subtitle {
        font-size: 16px;
        margin-bottom: 4px;
      }
      #hpo-categories .hpo-category-price {
        font-size: 16px;
      }

      #${ROOT_ID} #hpo-stories {
        --hpo-max: var(--hpo-max-secondary);
      }
      #hpo-stories .hpo-stories-grid {
        display: grid;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        gap: 20px;
      }
      #hpo-stories .hpo-story {
        position: relative;
        aspect-ratio: 286 / 376;
        overflow: hidden;
        background: #000000;
      }
      #hpo-stories .hpo-story-video {
        width: 100%;
        height: 100%;
        max-width: none;
        object-fit: cover;
        cursor: pointer;
      }

      #${ROOT_ID} #hpo-footer {
        --hpo-max: var(--hpo-max-secondary);
      }
      #hpo-footer {
        padding: 48px 0 32px;
        background: #EBEBEB;
        color: var(--hpo-header-bg);
        font-size: 12px;
      }

      #hpo-footer .hpo-footer-top {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 48px;
      }
      #hpo-footer .hpo-footer-links {
        display: flex;
        gap: 64px;
      }
      #hpo-footer .hpo-footer-col li + li {
        margin-top: 8px;
      }
      #hpo-footer .hpo-footer-heading {
        font-size: 12px;
        font-weight: 600;
      }
      #hpo-footer .hpo-footer-col li + .hpo-footer-heading {
        margin-top: 20px;
      }
      #hpo-footer .hpo-footer-link {
        font-size: 12px;
        color: var(--hpo-header-bg);
        transition: opacity 0.15s ease;
      }
      #hpo-footer .hpo-footer-link:hover {
        opacity: 0.6;
      }
      #hpo-footer .hpo-footer-app-title {
        font-size: 12px;
        margin-bottom: 12px;
      }
      #hpo-footer .hpo-footer-app-badges {
        display: flex;
        align-items: center;
        gap: 8px;
      }
      #hpo-footer .hpo-footer-app-badge img {
        height: 36px;
        width: auto;
      }

      #hpo-footer .hpo-footer-social {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-top: 40px;
      }
      #hpo-footer .hpo-social-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 32px;
        height: 32px;
        background: #000000;
        color: #FFFFFF;
        transition: opacity 0.15s ease;
      }
      #hpo-footer .hpo-social-btn:hover {
        opacity: 0.75;
      }
      #hpo-footer .hpo-social-btn svg {
        width: 16px;
        height: 16px;
      }

      #hpo-footer .hpo-footer-bottom {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        margin-top: 40px;
        font-size: 12px;
        color: var(--hpo-header-bg);
      }
      #hpo-footer .hpo-footer-copyright--mobile {
        display: none;
      }
      #hpo-footer .hpo-footer-legal-links {
        display: flex;
        align-items: center;
        gap: 8px;
      }
      #hpo-footer .hpo-footer-legal-links a:hover {
        opacity: 0.6;
      }

      @keyframes hpo-trusted-marquee {
        from {
          transform: translateX(0);
        }
        to {
          transform: translateX(-50%);
        }
      }

      /* ── mobile: 749 to match the theme's own breakpoint ── */
      @media (max-width: 749px) {
        #${ROOT_ID} .hpo-section {
          padding: 20px 0;
        }
        #hpo-showcase .hpo-showcase-grid {
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 12px;
          padding: 0 var(--hpo-gutter);
        }
        #hpo-showcase .hpo-tv-copy {
          padding: 20px 8px 0;
        }
        #hpo-showcase .hpo-tv-name {
          font-size: 16px;
          margin-bottom: 6px;
        }
        #hpo-showcase .hpo-tv-spec {
          font-size: 12px;
          margin-bottom: 6px;
        }
        #hpo-showcase .hpo-tv-price {
          font-size: 13px;
        }
        #hpo-showcase .hpo-tv .hpo-btn {
          padding: 9px 16px;
          font-size: 13px;
        }
        #${ROOT_ID} .hpo-carousel-nav {
          display: none;
        }
        #${ROOT_ID} #hpo-features {
          padding: 0;
        }
        #hpo-features .hpo-features-grid {
          grid-template-columns: 1fr;
          gap: 12px;
          padding: 0;
        }
        #${ROOT_ID} .hpo-feature:not(.hpo-feature--video) {
          background-image: var(
            --hpo-feature-bg-mobile,
            var(--hpo-feature-bg, none)
          );
          background-size: cover;
        }
        #${ROOT_ID} {
          --hpo-feature-h: 479px;
        }
        #${ROOT_ID} .hpo-section-title {
          font-size: 24px;
        }
        #${ROOT_ID} #hpo-showcase {
          padding: 40px 0;
        }
        #${ROOT_ID} .hpo-showcase-subtitle {
          font-size: 16px;
          margin-bottom: 12px;
        }
        #${ROOT_ID} .hpo-showcase-actions {
          margin-bottom: 10px;
        }
        #${ROOT_ID} .hpo-btn {
          padding: 10px 14px;
          font-size: 14px;
        }
        #${ROOT_ID} .hpo-feature-copy {
          padding: 40px 20px 0;
        }
        #${ROOT_ID} .hpo-feature-title {
          font-size: 24px;
        }
        #${ROOT_ID} .hpo-feature-subtitle {
          font-size: 16px;
        }
        #${ROOT_ID} .hpo-feature-price {
          margin-bottom: 12px;
        }
        #hpo-categories .hpo-categories-carousel {
          padding: 0;
        }
        #hpo-categories .hpo-category {
          flex: 0 0 290px;
          height: auto;
          display: flex;
          flex-direction: column;
          background-image: none !important;
        }
        #hpo-categories .hpo-category::before {
          display: none;
        }
        #hpo-categories .hpo-category-image {
          display: block;
          width: 100%;
          height: auto;
          max-width: 100%;
        }
        #hpo-categories .hpo-category-copy {
          position: static;
          padding: 12px 16px 16px;
        }
        #hpo-categories .hpo-category-title {
          font-size: 20px;
        }
        #hpo-categories .hpo-category-subtitle {
          font-size: 14px;
        }
        #hpo-categories .hpo-category-price {
          font-size: 14px;
        }
        #hpo-stories .hpo-stories-grid {
          display: flex;
          gap: 12px;
          overflow-x: auto;
          overflow-y: hidden;
          scroll-snap-type: x mandatory;
          padding: 0 max(var(--hpo-gutter), calc(50% - 143px));
          margin: 0 calc(var(--hpo-gutter) * -1);
          scrollbar-width: none;
          -ms-overflow-style: none;
        }
        #hpo-stories .hpo-stories-grid::-webkit-scrollbar {
          display: none;
        }
        #hpo-stories .hpo-story {
          flex: 0 0 286px;
          scroll-snap-align: center;
        }
        #${ROOT_ID} #hpo-trusted {
          padding: 50px 0;
        }
        #hpo-trusted .hpo-trusted-track {
          justify-content: flex-start;
          gap: 16px;
          width: max-content;
          animation: hpo-trusted-marquee 30s linear infinite;
        }
        @media (prefers-reduced-motion: reduce) {
          #hpo-trusted .hpo-trusted-row {
            overflow-x: auto;
            scrollbar-width: none;
          }
          #hpo-trusted .hpo-trusted-track {
            animation: none;
          }
        }
        #hpo-trusted .hpo-trusted-logo {
          flex: 0 0 auto;
        }
        #hpo-trusted .hpo-trusted-logo,
        #hpo-trusted .hpo-trusted-logo img,
        #hpo-trusted .hpo-trusted-placeholder {
          height: 40px;
          max-height: 40px;
        }
        #hpo-footer .hpo-footer-top {
          flex-direction: column;
          gap: 32px;
        }
        #hpo-footer .hpo-footer-links {
          flex-wrap: wrap;
          gap: 32px 48px;
        }
        #hpo-footer .hpo-footer-bottom {
          flex-direction: column;
          align-items: flex-start;
          gap: 12px;
        }
        #hpo-footer .hpo-footer-legal-links {
          order: -1;
        }
        #hpo-footer .hpo-footer-copyright {
          display: none;
        }
        #hpo-footer .hpo-footer-copyright--mobile {
          display: block;
        }
        #hpo-footer .hpo-footer-region {
          display: none;
        }
      }

      /* ── hero: stacked treatment ──
         <=900 so it changes together with the shortcuts row. Must stay AFTER
         the base hero rules - same specificity, so source order decides. */
      @media (max-width: 900px) {
        #${ROOT_ID} #hpo-hero {
          --hpo-hero-art-h: 320px;
          display: block;
          position: relative;
          overflow: hidden;
          height: auto;
          padding: 0;
          /* the background-image is set inline, so this needs !important */
          background-image: none !important;
          background-color: #0B0B0B;
        }
        #hpo-hero::before {
          display: none;
        }
        #hpo-hero .hpo-hero-media {
          display: block;
          position: relative;
          overflow: hidden;
        }
        #hpo-hero .hpo-hero-media::after {
          content: "";
          position: absolute;
          inset: 0;
          background: linear-gradient(
            to bottom,
            var(--hpo-band-0) 35%,
            var(--hpo-band) 100%
          );
          pointer-events: none;
        }
        #hpo-hero .hpo-hero-image {
          display: block;
          width: 100%;
          height: var(--hpo-hero-art-h);
          max-width: 100%;
          object-fit: cover;
          object-position: center;
        }
        #hpo-hero .hpo-hero-inner {
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 1;
          margin-top: 0;
          padding-top: 0;
          padding-bottom: 20px;
        }
        #hpo-hero .hpo-hero-eyebrow {
          font-size: 13px;
          margin-bottom: 4px;
        }
        #hpo-hero .hpo-hero-title {
          gap: 8px;
          font-size: 24px;
          margin-bottom: 6px;
        }
        #hpo-hero .hpo-hero-copy {
          font-size: 16px;
          margin-bottom: 12px;
        }
      }

      #hpo-bundle-bar {
        background: #6E0608;
        color: #FFFFFF;
      }
      #hpo-bundle-bar .hpo-bundle-bar-inner {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        gap: 4px 6px;
        min-height: var(--hpo-header-h);
        padding: 8px var(--hpo-gutter);
        font-size: 14px;
        text-align: center;
      }
      #hpo-bundle-bar .hpo-bundle-bar-text--mobile {
        display: none;
      }
      #hpo-bundle-bar .hpo-bundle-bar-link {
        color: #FFFFFF;
        font-weight: 500;
        text-decoration: underline;
        text-underline-offset: 2px;
        white-space: nowrap;
        transition: color 0.15s ease;
      }
      /* !important to beat the scoped reset's a:focus colour. */
      #hpo-bundle-bar .hpo-bundle-bar-link:hover,
      #hpo-bundle-bar .hpo-bundle-bar-link:focus,
      #hpo-bundle-bar .hpo-bundle-bar-link:active {
        color: #F2D9D9 !important;
      }

      /* ── shortcuts row: one line above 900px, 3x3 pills at or below ── */
      #${ROOT_ID} #hpo-shortcuts {
        --hpo-max: var(--hpo-max-secondary);
        background: var(--hpo-bg);
        padding: 20px 0;
      }
      #hpo-shortcuts .hpo-shortcuts-row {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 12px;
      }
      #hpo-shortcuts .hpo-shortcut {
        flex: 1 1 0;
        min-width: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 10px;
        padding: 8px 4px;
        color: var(--hpo-ink);
        text-align: center;
        transition: background-color 0.15s ease, border-color 0.15s ease;
      }
      #hpo-shortcuts .hpo-shortcut:hover {
        background: rgba(17, 17, 17, 0.04);
      }
      #hpo-shortcuts .hpo-shortcut-media {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 56px;
      }
      #hpo-shortcuts .hpo-shortcut-image {
        width: auto;
        max-width: 100%;
        max-height: 56px;
      }
      #hpo-shortcuts .hpo-shortcut-label {
        font-size: 13px;
        font-weight: 700;
      }

      /* ── promo carousel ── */
      #${ROOT_ID} #hpo-promos {
        --hpo-max: var(--hpo-max-secondary);
        padding: 40px 0;
      }
      #hpo-promos .hpo-promos-head {
        text-align: center;
      }
      #hpo-promos .hpo-section-title {
        margin-bottom: 4px;
      }
      #hpo-promos .hpo-promos-countdown {
        font-size: 16px;
        margin-bottom: 28px;
      }
      #hpo-promos .hpo-promos-countdown b {
        font-weight: 700;
        font-variant-numeric: tabular-nums;
      }
      #hpo-promos .hpo-promos-carousel {
        position: relative;
        max-width: var(--hpo-max);
        margin: 0 auto;
      }
      #hpo-promos .hpo-promos-track {
        display: flex;
        gap: 20px;
        overflow-x: auto;
        overflow-y: hidden;
        scroll-snap-type: x mandatory;
        /* Used for BOTH padding-left and scroll-padding-left: if they
           differ, the first card loads clipped. */
        --hpo-track-pad: max(
          var(--hpo-gutter),
          calc((100% - var(--hpo-max)) / 2 + var(--hpo-gutter))
        );
        scroll-padding-left: var(--hpo-track-pad);
        padding: 0 var(--hpo-track-pad);
        scrollbar-width: none;
        -ms-overflow-style: none;
      }
      #hpo-promos .hpo-promos-track::-webkit-scrollbar {
        display: none;
      }
      #hpo-promos .hpo-promo {
        position: relative;
        display: block;
        flex: 0 0 380px;
        height: 390px;
        overflow: hidden;
        scroll-snap-align: start;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        text-align: center;
      }
      #hpo-promos .hpo-promo::before {
        content: "";
        position: absolute;
        inset: 0;
        pointer-events: none;
      }
      #hpo-promos .hpo-promo--dark::before {
        background: linear-gradient(
          to bottom,
          #000000 0%,
          rgba(0, 0, 0, 0) 50%
        );
      }
      #hpo-promos .hpo-promo--light::before {
        background: linear-gradient(
          to bottom,
          #FFFFFF 0%,
          rgba(255, 255, 255, 0) 50%
        );
      }
      #hpo-promos .hpo-promo-copy {
        position: relative;
        z-index: 1;
        padding: 28px 24px 0;
      }
      #hpo-promos .hpo-promo-eyebrow {
        font-size: 16px;
        margin-bottom: 6px;
      }
      #hpo-promos .hpo-promo-title {
        font-size: 24px;
        font-weight: 700;
        margin-bottom: 10px;
      }
      #hpo-promos .hpo-promo-body {
        font-size: 16px;
        min-height: 2.8em;
        margin-bottom: 10px;
        /* Centres a one-line body. The copy sits in a single <span> so the
           <b> inside stays inline rather than becoming its own flex item. */
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
      #hpo-promos .hpo-promo-body b {
        font-weight: 700;
      }
      #hpo-promos .hpo-promo-price {
        font-size: 16px;
        margin-bottom: 16px;
      }

      #hpo-promos .hpo-promo--dark {
        background-color: #0B0B0B;
        color: #FFFFFF;
      }
      #hpo-promos .hpo-promo--dark .hpo-promo-eyebrow {
        color: #E3A33C;
      }
      #hpo-promos .hpo-promo--light {
        background-color: #F2F2F2;
        color: var(--hpo-header-bg);
      }
      #hpo-promos .hpo-promo--light .hpo-promo-eyebrow {
        color: #C22026;
      }

      @media (max-width: 749px) {
        #${ROOT_ID} #hpo-promos {
          padding: 32px 0;
        }
        #hpo-promos .hpo-promos-countdown {
          font-size: 14px;
          margin-bottom: 20px;
        }
        #hpo-promos .hpo-promo {
          flex: 0 0 290px;
          height: 350px;
        }
        #hpo-promos .hpo-promo-eyebrow {
          font-size: 14px;
        }
        #hpo-promos .hpo-promo-title {
          font-size: 20px;
          margin-bottom: 6px;
        }
        #hpo-promos .hpo-promo-body {
          font-size: 14px;
          margin-bottom: 6px;
        }
        #hpo-promos .hpo-promo-price {
          font-size: 14px;
          margin-bottom: 12px;
        }
      }

      @media (max-width: 749px) {
        #hpo-bundle-bar .hpo-bundle-bar-inner {
          gap: 4px;
          padding: 10px var(--hpo-gutter);
          font-size: 12px;
        }
        #hpo-bundle-bar .hpo-bundle-bar-text {
          display: none;
        }
        #hpo-bundle-bar .hpo-bundle-bar-text--mobile {
          display: inline;
        }
      }

      @media (max-width: 900px) {
        #${ROOT_ID} #hpo-shortcuts {
          background: var(--hpo-band);
        }
        #hpo-shortcuts .hpo-shortcuts-row {
          display: grid;
          grid-template-columns: repeat(3, minmax(0, 1fr));
          gap: 8px;
        }
        #hpo-shortcuts .hpo-shortcut {
          justify-content: center;
          min-height: 30px;
          padding: 5px 6px;
          background: #FFFFFF;
        }
        #hpo-shortcuts .hpo-shortcut:hover {
          border-color: var(--hpo-header-bg);
          background: #FFFFFF;
        }
        #hpo-shortcuts .hpo-shortcut-media {
          display: none;
        }
        #hpo-shortcuts .hpo-shortcut-label {
          font-size: 12px;
        }
      }

    `;
    document.head.appendChild(style);
  }
})();
